import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {BuilderPaneBase} from 'common/widgets/cohorts-query-builder/common-components/builder-pane-base/index';
import {BehaviorCountType} from 'common/widgets/cohorts-query-builder/models/enums/expression-enums';

import template from './index.jade';
import css from './index.styl?inline';

const COUNT_TYPE_OPTIONS = [
  {
    label: `Times`,
    value: BehaviorCountType.Absolute,
  },
  {
    label: `Times, on unique days`,
    value: BehaviorCountType.Day,
  },
];

class CohortsBuilderDistinctDay extends BuilderPaneBase {
  get config() {
    return {
      ...super.config,
      useShadowDom: true,
      css,
      template,
      helpers: {
        ...super.config.helpers,
        COUNT_TYPE_OPTIONS,
        clickedOption: (behaviorCountType) => {
          this.dispatchBubbledEvent(`selected-behavior-count-type`, behaviorCountType);
        },
        getBehaviorCountType: () => {
          const {stagedCohort, stagedClausePosition} = this.state;
          return stagedCohort.getBehavior(stagedClausePosition).count.type;
        },
      },
    };
  }
}

export const CohortsBuilderDistinctDayEl = defineAndMakeJsxFactory(
  `cohorts-builder-distinct-day`,
  CohortsBuilderDistinctDay,
);
